module.exports = __webpack_public_path__ + "img/rating.76224141.svg";